type SponsorInfo = { referal?: number | string } | null

// Only an explicit zero from base-info triggers this product restriction.
export function requiresSponsor(profile: SponsorInfo): boolean {
  return profile?.referal === 0 || profile?.referal === '0'
}

export function sponsorRouteRedirect(profile: SponsorInfo, routeName: unknown) {
  return requiresSponsor(profile) && routeName !== 'profile'
    ? { name: 'profile', replace: true } as const
    : null
}
